import { isCliAuthPath } from './publicRoutes'

const CLI_AUTH_RETURN_KEY = 'veilstream_cli_auth_return'

function readCliAuthReturnPath(): string | null {
  try {
    const raw = sessionStorage.getItem(CLI_AUTH_RETURN_KEY)
    if (!raw) return null
    const pathname = raw.split('?')[0]
    if (!isCliAuthPath(pathname)) return null
    return raw
  } catch {
    return null
  }
}

/** Persist /cli/auth, /cli/login, or /cli/device across the GitHub/Google OAuth round-trip. */
export function stashCliAuthReturn(path = `${window.location.pathname}${window.location.search}`): void {
  const pathname = path.split('?')[0]
  if (!isCliAuthPath(pathname)) return
  try {
    sessionStorage.setItem(CLI_AUTH_RETURN_KEY, path)
  } catch {
    /* ignore */
  }
}

export function peekCliAuthReturnPath(): string | null {
  return readCliAuthReturnPath()
}

export function consumeCliAuthReturnPath(): string | null {
  const path = readCliAuthReturnPath()
  if (!path) return null
  try {
    sessionStorage.removeItem(CLI_AUTH_RETURN_KEY)
  } catch {
    /* ignore */
  }
  return path
}

/** After ToS accept, resume CLI authorize/device instead of dropping the user on /projects. */
export function destinationAfterTermsAccept(cliReturnPath: string | null, fallback = '/projects'): string {
  if (!cliReturnPath) return fallback
  const pathname = cliReturnPath.split('?')[0]
  if (!isCliAuthPath(pathname)) return fallback
  return cliReturnPath
}

export function pathAfterTermsAccept(fallback = '/projects'): string {
  return destinationAfterTermsAccept(consumeCliAuthReturnPath(), fallback)
}
